import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { FreshdeskTicket } from "./freshdeskTicket"
import { IFreshdeskTicket } from "./freshdeskTicket.types"
import IFreshdeskConversationRaw, {
  FreshdeskConversationParser,
  IFreshdeskAttachmentRaw,
} from "../freshdeskThreadConversation/freshdeskThreadConversation.parser"

export interface ICustomFieldsRaw {
  [key: string]: string | number | boolean | null
}

export interface IFreshdeskTicketRaw {
  id: number
  ticket_type: string | null
  created_at: string
  updated_at: string
  subject: string
  source: number
  status: number
  group_id: number
  spam: boolean
  notes: IFreshdeskConversationRaw[]
  description: string
  description_html: string
  incoming: boolean
  private: boolean
  to_emails: string[]
  attachments: IFreshdeskAttachmentRaw[]
  requester: {
    email: string
  }
}

export const FreshdeskTicketParser: IParser<
  IFreshdeskTicket,
  IFreshdeskTicketRaw
> = {
  toDomain: (data: IFreshdeskTicketRaw) => {
    try {
      return new FreshdeskTicket(
        data.id,
        data.ticket_type ?? "",
        dayjs(data.created_at),
        dayjs(data.updated_at),
        data.subject,
        data.source,
        data.status,
        data.group_id,
        data.spam,
        [
          FreshdeskConversationParser.toDomain({
            id: data.id,
            description: data.description,
            body_html: data.description_html,
            incoming: true,
            private: data.private,
            created_at: data.created_at,
            to_emails: data.to_emails,
            attachments: data.attachments,
            subject: data.subject,
            from_email: data.requester.email,
          }),
          ...data.notes.map((note) =>
            FreshdeskConversationParser.toDomain(note),
          ),
        ],
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
